import { render, staticRenderFns } from "./TeamsCreate.vue?vue&type=template&id=dd0c144c&scoped=true"
import script from "./TeamsCreate.vue?vue&type=script&lang=js"
export * from "./TeamsCreate.vue?vue&type=script&lang=js"
import style0 from "./TeamsCreate.vue?vue&type=style&index=0&id=dd0c144c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0c144c",
  null
  
)

export default component.exports